<template>
  <div class="feedback">
    <el-dialog
      class="feedbackVisible"
      title="提示"
      :visible.sync="$store.state['zsm-dict']['feedbackVisible']"
      width="640px"
    >
      <div slot="title">提交反馈意见</div>
      <div class="feedback-con">
        <el-alert
          type="warning"
          :closable="false"
        >
          <div slot="title" class="warning-title flex flex-align-center">

            <svg-icon icon-class="icon_warning" />
            <div style="line-height: 1"> 请详细描述反馈问题，可能会获得我们的回复</div>
           </div>
        </el-alert>

        <div>
          <el-form ref="feedbackForm2" :model="feedbackForm" label-width="83px" :rules="feedbackRules">
            <el-form-item label="问题原因" :required="true" prop="qaDict">
              <el-select v-model="feedbackForm.qaDict" placeholder="请选择问题原因">
                <el-option v-for="item of feedbackDict" :label="item.dictLabel" :value="item.dictValue" />
              </el-select>
            </el-form-item>

            <el-form-item label="问题描述" :required="true" prop="qaDesc">
              <el-input v-model="feedbackForm['qaDesc']" type="textarea" :maxlength="500" show-word-limit placeholder="请输入问题描述" @change="changeDesc" />
            </el-form-item>

            <el-form-item label="手机号" :required="true" prop="mobile">
              <el-input v-model="feedbackForm['mobile']" placeholder="请输入您的联系方式"/>
            </el-form-item>

            <el-form-item label="标记内容" style="margin-top: 30px">
              <div class="flex" style="flex-wrap: wrap">
                <div
                  v-for="(item,index) of uploadImgList"
                  style="position: relative;top: 0px;margin-right: 20px;border-radius: 6px"
                  @mouseleave="uploadImgRemoveIndex=null"
                >
                  <div v-if="uploadImgRemoveIndex==index" class="avator flex" style="cursor: pointer;border-radius: 6px;position: absolute;background:rgba(0,0,0,0.28);top:0;align-items: center;justify-content: center">

                    <i class="el-icon-delete" style="color:#fff;font-size: 20px" @click="uploadImgList.splice(index,1)" />
                    <i class="el-icon-search" style="color:#fff;font-size: 20px;margin-left: 15px" @click="$store.state['zsm-dict'].examplesImage=item;$store.state['zsm-dict'].examplesModal=true;" />
                  </div>
                  <img v-if="uploadImgList.length>0" :src="item" class="avator" @mouseenter="uploadImgRemoveIndex=index">
                </div>
                <el-upload
                  style="margin-top: 0px;"
                  class="upload-demo avator "
                  drag
                  :before-upload="beforeAvatarUpload5"
                  action="https://joofish.com/"
                >
                  <div class="avator">
                    <svg-icon icon-class="fa-camera" />
                  </div>
                </el-upload>
              </div>

            </el-form-item>

            <div class="submitFeedbackForm">
              <el-button type="primary" @click="submitFeedbackForm('feedbackForm2')">完成并提交</el-button>
              <el-button @click="$store.state['zsm-dict']['feedbackVisible'] = false">取消</el-button>
            </div>
          </el-form>
        </div>

      </div>
    </el-dialog>



  </div>
</template>

<script>
export default {
  name: 'Feedback',
  data() {
    return {
      uploadImgRemoveIndex: -1, // 删除图片
      uploadImgList: [], // 详情图
      feedbackVisible: true,
      feedbackDict: [], //
      feedbackForm: {
        mobile:'',//手机号
        qaDict: '', // 问题原因
        qaDesc: '', // 问题描述
        qaImg: ''// 问题图片
      },
      feedbackRules: {
        qaDict: [
          {
            required: true,
            message: '请请选择问题原因',
            trigger: 'change'
          },
          {
            required: true,
            message: '请请选择问题原因',
            trigger: 'blur'
          },
          {
            required: true,
            message: '请请选择问题原因',
            trigger: 'submit'
          }

        ],
        mobile: [
          {
            required: true,
            message: '请输入您的联系方式',
            trigger: 'change'
          },
          { min:11, max: 11, message: '请输入正确的联系方式', trigger: 'blur' },
          {
            required: true,
            message: '请输入您的联系方式',
            trigger: 'blur'
          },
          {
            required: true,
            message: '请输入您的联系方式',
            trigger: 'submit'
          }

        ],
        qaDesc: [
          {
            required: true,
            message: '请输入问题描述',
            trigger: 'blur'
          },
          {
            required: true,
            message: '请输入问题描述',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 500,
            message: '问题描述文字限制为1-500',
            trigger: 'blur'
          },
          {
            required: true,
            message: '请输入问题描述',
            trigger: 'change'
          }
        ]
      } // 内容验证
    }
  },
  mounted() {
    this.$store.dispatch('zsm-dict/settingDict', 'zsm_user_feedback_dict').then((info) => {
      this.feedbackDict = info
    })
  },
  methods: {
    // 修改问题描述
    changeDesc(e) {
      // this.feedbackForm.qaDesc=e
    },
    // 提交反馈
    submitFeedbackForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.feedbackForm.qaImg = this.uploadImgList.join('|')
          console.log(this.feedbackForm)
        } else {
          return false
        }
      })
    },
    // 反馈图
    beforeAvatarUpload5: function(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        this.$message.error('请上传图片!')
        return false
      }
      // 上传图片到七牛云
      this.$store.state.uploadByQiniu.qiniuData.file = file
      this.$store.dispatch('uploadByQiniu/getQiniuyunToken').then((response) => {
        this.$store.dispatch('uploadByQiniu/uploadQiniuUp', this.$store.state.uploadByQiniu.qiniuData).then((
          response) => {
          this.uploadImgList.push(this.$store.state.uploadByQiniu.upload_qiniu_addr + response.key)
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .feedback::v-deep{
    
    .feedbackVisible{
      .el-dialog{
        border-radius: 4px;
        -webkit-box-shadow: 0px 4px 16px 0px rgb(37 41 49 / 8%);
        box-shadow: 0px 4px 16px 0px rgb(37 41 49 / 8%);
        pointer-events: auto;
      }

    .el-form-item__error{
      margin-top: 5px;
      position: static;
    }
    .el-dialog__body{
      padding: 0;
    }
    .el-upload-list__item:first-child{
      margin-top: -50px;
    }
    .submitFeedbackForm{
      line-height: 1.15;
      -webkit-font-smoothing: antialiased;
      text-rendering: optimizeLegibility;
      font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
      padding:10px 0 40px 0;
      text-align: right;
      justify-content: flex-end;
      box-sizing: border-box;
    }
    .el-upload,
    .el-upload-dragger {
      width: auto;
      height: 140px;
      border: none;
      svg {
        color: #fff;
        font-size: 40px;
        margin-top: 50px
      }
    }
    .feedback-con{
      padding: 24px 24px 0;
      font-size: 14px;
      line-height: 1.5715;
      .avator {
        margin-bottom: 15px;
        border-radius: 6px;
        font-size: 14px;
        background-color: rgba(247, 249, 250, 1);
        width: 140px;
        height: 140px;
        text-align: center;
        -o-object-fit: cover;
        object-fit: cover;
        object-position:top;
        vertical-align: top;
        /*padding-top: 45px;*/
      }
      .el-form{
        .el-select{
          width: 100%;
        }
        textarea{
          resize: none !important;
          font-size: 14px;
          font-variant: tabular-nums;
          line-height: 1.5715;
          list-style: none;
          width: 100%;
          height: 94px;
          padding-bottom: 20px !important;
          border: 1px solid #dcdee1;
          border-radius: 4px;
          transition: all 0.3s;
          outline: none;
          background-color: #ffffff;
        }
        input{
          width: 100%;
          font-size: 14px;
          height: 35px;
          line-height: 35px;
          &::placeholder{
            font-size: 14px;
          }
        }
        .el-form-item__label{
          font-weight: normal;
          color: #565960
        }
      }
      .el-alert{
        background-color: #ffecd1;
        margin-bottom: 24px;
        border: 1px solid rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        height: 40px;
        font-size: 12px;
        line-height: 16px;
        .svg-icon{
          font-size: 16px;
          margin-right: 8px;
          height: 16px;
          color: #ff9226;
        }
      }
      .el-alert__content{
        //margin-top: 2px;
      }
      .warning-title{
        color: #252931;
        align-items: center;
        line-height: 18px;
      }
    }
      .el-dialog__header{
        padding: 16px 24px;
        border-bottom: 1px solid #eeeff0;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        .el-icon-close{
          font-size: 20px;
        }
        div{
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          --antd-wave-shadow-color: #1966ff;
          --scroll-bar: 0;
          --sash-size: 4px;
          font-variant: tabular-nums;
          font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol !important;
          -webkit-font-smoothing: antialiased;
          list-style: none;
          font-feature-settings: 'tnum';
          text-align: left;
          pointer-events: auto;
          margin: 0;
          color: #252931;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          box-sizing: border-box;
        }
      }
  }
  }
</style>
